import { sortBy } from 'lodash'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import { Pagination } from '@/interfaces/paginatedResponse'

import { User } from '@/modules/users/interfaces/user'
import type { UserFilters } from '@/modules/users/interfaces/userFilters'

const defaults = {
	filters: {
		search: '',
		company: undefined,
		status: 'active',
		role: undefined,
		group: undefined,
		department: undefined,
		sortBy: 'name',
		sortDirection: 'asc',
	},
}

export const useUsersStore = defineStore('users', () => {
	const users = ref<User[]>([])
	const email = ref<string>()
	const filters = ref<UserFilters>({ ...defaults.filters })
	const pagination = ref<Pagination>()
	const includes = ref<string[]>([])
	const page = ref<string>('1')

	return {
		email,
		users,
		filters,
		pagination,
		includes,
		page,

		setUsers(newusers: User[]) {
			users.value = []
			users.value = newusers
		},

		setFiltersValue<T extends keyof UserFilters>(
			property: T,
			value: UserFilters[T]
		) {
			filters.value[property] = value
		},

		setPagination(newMeta: Pagination) {
			pagination.value = newMeta
		},

		setIncludes(newIncludes: string[]) {
			includes.value = newIncludes
		},

		setPage(newPage: string) {
			page.value = newPage
		},

		resetFilters() {
			filters.value = { ...defaults.filters }
		},
	}
})
